<div class="jumbotron explanation-mobile-jumbotron">
	<div class="mobile-explanation-title" (click)="statusCollapse = !statusCollapse">
		<div class="explanation-img">
			<img src="/../../assets/img/{{themeService.theme}}/delegate.svg" alt="">
		</div>
		<div class="title">
			How <br> Shared Plan <br> Works
		</div>
		<i class="fa fas fa-chevron-down"></i>
	</div>
	<section class="mobile-explanations" [ngClass]="statusCollapse? 'mobile-explanations-collapsed' : ''">
		<div class="rights">
			<div class="div-opacity div-opacity-contributor">
				<i class="fa fas fa-pen-alt contributor-fa"></i>
				<div class="contributor rights-div">Contributor</div>
			</div>
		</div>
		<p>Allow your delegate to add and edit items in this section, perfect for building your plan with your partner
			or collobrating with an advisor.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-now">
				<i class="fa fas fa-eye viewer-now-fa"></i>
				<div class="viewer-now rights-div">Viewer - Now</div>
			</div>
		</div>
		<p>Allow your delegate to view this section, this is great for sharing information with family, friends and
			advisors.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-future">
				<i class="fa fas fa-eye viewer-future-fa"></i>
				<div class="viewer-future rights-div">Viewer - Future</div>
			</div>
		</div>
		<p>Keep this section hidden from your delegate but allow them to request access if you pass away or become
			incapacitated.</p>
		<div class="rights">
			<div class="div-opacity div-opacity-no-access">
				<i class="fa fas fa-lock no-access-fa"></i>
				<div class="no-access rights-div">No Access</div>
			</div>
		</div>
		<p>Keep this section hidden permanently hidden from your delegate.</p>
	</section>
</div>